export const DailyDTRReportModal: string = 'DailyDTRReportDTRModal';
